import { render, staticRenderFns } from "./bjUpload.vue?vue&type=template&id=df8165f4&scoped=true"
import script from "./bjUpload.vue?vue&type=script&lang=js"
export * from "./bjUpload.vue?vue&type=script&lang=js"
import style0 from "./bjUpload.vue?vue&type=style&index=0&id=df8165f4&prod&lang=less"
import style1 from "./bjUpload.vue?vue&type=style&index=1&id=df8165f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8165f4",
  null
  
)

export default component.exports